<div class="promotional-tools-card">
  <div class="promotional-tools-card__glow" aria-hidden="true"></div>

  <div class="promotional-tools-card__inner">
    @if (showBadge()) {
      <div class="promotional-tools-card__badge">
        <app-icon name="star" [size]="14" color="#ffffff"></app-icon>
        <span>{{ badgeKey() | translateLang }}</span>
      </div>
    }

    <div class="promotional-tools-card__icon-badge" aria-hidden="true"></div>

    <p class="promotional-tools-card__title">{{ titleKey() | translateLang }}</p>
    <p class="promotional-tools-card__description">{{ descriptionKey() | translateLang }}</p>

    <button type="button" class="promotional-tools-card__cta" (click)="onClick()">
      {{ ctaLabelKey() | translateLang }}
    </button>
  </div>
</div>
